import { Box, Card } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import WTypography from 'Components/whiteTypography'
import { Bar } from 'react-chartjs-2'
import CustomButton from 'Components/CustomButton/CustomButton'
import SettingsIcon from '@mui/icons-material/Settings'
import ValeurSetting from './ValeurSetting'
import moment from 'moment'
import EmptyDataShortcut from './EmptyDataShortcut'

function ValeurHoraire({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const user = useSelector((store) => store.user.user)
  // Devise par défaut de l'utilisateur (user.currency_code) au lieu du € en dur.
  // On dérive le symbole via Intl, puis on l'injecte dans le libellé i18n
  // existant ("€/Heure", "€/Hour", …) en remplaçant le €.
  const currencySymbol = useMemo(() => {
    const code = user?.currency_code || 'EUR'
    try {
      return (
        new Intl.NumberFormat(undefined, { style: 'currency', currency: code })
          .formatToParts(0)
          .find((p) => p.type === 'currency')?.value || code
      )
    } catch (e) {
      return code
    }
  }, [user?.currency_code])
  const [openSetting, setOpenSetting] = useState(false)
  const [viewType, setViewType] = useState('year')
  const [data, setRevData] = useState({
    labels: ['2021', '2022', '2023', '2024'],

    datasets: [
      {
        data: [4, 9, 2, 4],
        borderColor: ['#c1daf1'],
        backgroundColor: ['#c1daf1'],
        borderWidth: 1,
        barThickness: 15,
      },
    ],
  })

  const optionsbar = {
    indexAxis: 'x',
    aspectRatio: 1.05,

    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    scales: {
      x: {
        ticks: {
          color: 'white',
          callback: function (e) {
            let label = ''
            if (viewType === 'year') label = data.labels[e]
            else label = moment(data.labels[e]).format('MMM YY')
            return label
          },
        },
        grid: {
          color: 'rgba(255,255,255,0.1)',
        },
      },
      y: {
        ticks: {
          color: 'white',
        },
        grid: {
          color: 'rgba(255,255,255,0.1)',
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        color: 'white',
        formatter: (val, ctx) => ctx.chart.data.labels[ctx.dataIndex],
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }

  useEffect(() => {
    setRevData({
      labels: oldData.by_year.label,

      datasets: [
        {
          data: oldData.by_year.data,
          borderColor: ['#c1daf1'],
          backgroundColor: ['#c1daf1'],
          borderWidth: 1,
          barThickness: 15,
        },
      ],
    })
  }, [])

  const handelView = (v) => {
    if (v === 'month') {
      setViewType('month')
      setRevData({
        labels: oldData.by_month.label,

        datasets: [
          {
            data: oldData.by_month.data,
            borderColor: ['#c1daf1'],
            backgroundColor: ['#c1daf1'],
            borderWidth: 1,
            barThickness: 15,
          },
        ],
      })
    }
    if (v === 'year') {
      setViewType('year')
      setRevData({
        labels: oldData.by_year.label,

        datasets: [
          {
            data: oldData.by_year.data,
            borderColor: ['#c1daf1'],
            backgroundColor: ['#c1daf1'],
            borderWidth: 1,
            barThickness: 15,
          },
        ],
      })
    }
  }
  return (
    <>
      {openSetting && (
        <ValeurSetting setOpenSetting={setOpenSetting} updateReports={updateReports} />
      )}
      <Card className="dashboard_card__root1" sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box className="dashboard_card__header1 no-drag">
          <WTypography component={'span'} variant="h6">
            {t('professionnelle.valeurHoraire') /* LAP-733 (GE022) */}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {parseFloat(oldData.current_year).toFixed(2)}
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('professionnelle.revenuHoraireMoyen') /* LAP-733 (GE022) */}
          </WTypography>
          <WTypography sx={{ color: 'white' }} variant={'body2'}>
            {t('professionnelle.unitPerHour').replace('€', currencySymbol) /* LAP-733 (GE022) */}
          </WTypography>
        </Box>
        <Box mt={1} minWidth={3} mb={1} height={'100%'}>
          {oldData.show ? (
            <Bar data={data} options={optionsbar} />
          ) : (
            <EmptyDataShortcut
              title={t('professionnelle.emptyTitle') /* LAP-733 (GE022) */}
              description={t('professionnelle.valeurHoraireDesc') /* LAP-733 (GE022) */}
            />
          )}
        </Box>

        <Box
          mt={1}
          className=" no-drag"
          sx={{
            display: 'flex',
            position: 'unset !important',
            width: '100%',
            pr: '0px !important',
          }}
        >
          <CustomButton onClick={(e) => handelView('year')} style={{ padding: 0 }}>
            {t('professionnelle.btnYear') /* LAP-733 (GE022) */}
          </CustomButton>
          <CustomButton onClick={(e) => handelView('month')} style={{ padding: 0 }}>
            {t('professionnelle.btnMonth') /* LAP-733 (GE022) */}
          </CustomButton>

          <SettingsIcon
            onClick={() => setOpenSetting(true)}
            sx={{ color: 'white', marginLeft: 'auto', cursor: 'pointer' }}
          />
        </Box>
      </Card>
    </>
  )
}

export default ValeurHoraire
